import { DiskCreate } from "@/modules/disks/DiskCreate.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/disks/create")({
    component: DiskCreate,
});
